/**
 * Build the host-agnostic `/files/download/<filename>` API path for an image,
 * discarding any host baked into a stored or cached URL.
 *
 * Library item URLs are persisted absolute (built from the API base URL at
 * capture time). After a domain cutover a device's PWA cache can still hold the
 * previous host — e.g. the GKE-era `mechv2.apps.prod.wocozon.nl`, now a 301
 * redirect with no CORS headers, which fails the preflight on any XHR aimed at
 * it. Keeping only the filename lets the request resolve against axios' current
 * `baseURL` instead, so verification always hits the live API host.
 */
export function downloadPath(url: string): string {
  const filename = (url.split('/').pop() ?? '').split('?')[0];

  return `/files/download/${filename}`;
}
